import { useRoute, useState } from "#imports";
import { computed, ref } from "vue";
export function useHighlightElement(element, sliceId, elementStyles) {
  let el = null;
  if (import.meta.client) {
    el = document.getElementById(sliceId.value);
  }
  const outlinePosition = { left: ref(0), top: ref(0), bottom: ref(0), right: ref(0), width: ref(0), height: ref(0) };
  const currentlyManagingMarginsAndPadding = useState("currentlyManagingMarginsAndPadding", () => false);
  const currentlyHighlightedSlice = useState("voixCurrentlyHighlightedSlice", () => null);
  const currentlySelectedElements = useState("currentlySelectedElements", () => []);
  const isHighlighted = computed(() => {
    if (currentlyHighlightedSlice.value === element.id) {
      return true;
    }
    if (currentlySelectedElements.value.length === 0) {
      return currentlySelectedElements.value.find((selectedElement) => selectedElement.id === element.id) !== void 0;
    }
  });
  const isSelected = computed(() => {
    return typeof currentlySelectedElements.value.find((selectedElement) => selectedElement.id === element.id) !== "undefined";
  });
  const showHighlight = computed(() => {
    return isSelected.value || isHighlighted.value;
  });
  const highlightStyles = computed(() => {
    if (showHighlight.value === true) {
      if (currentlyManagingMarginsAndPadding.value) {
        return {
          top: outlinePosition ? `${outlinePosition.top.value}px` : "0",
          left: `${outlinePosition.left.value}px`,
          width: `${outlinePosition.width.value}px`,
          height: `${outlinePosition.height.value}px`,
          borderWidth: "2px",
          borderColor: "rgba(226, 135, 74, 0.5)",
          boxShadow: `inset 0 ${typeof elementStyles.value.paddingTop !== "undefined" && elementStyles.value.paddingTop !== "0px" ? elementStyles.value.paddingTop : 0} 0 0 rgba(74, 226, 144, 0.5), inset -${typeof elementStyles.value.paddingRight !== "undefined" && elementStyles.value.paddingRight !== "0px" ? elementStyles.value.paddingRight : 0} 0 0 0 rgba(74, 226, 144, 0.5), inset 0 -${typeof elementStyles.value.paddingBottom !== "undefined" && elementStyles.value.paddingBottom !== "0px" ? elementStyles.value.paddingBottom : 0}  0 0 rgba(74, 226, 144, 0.5), inset ${typeof elementStyles.value.paddingLeft !== "undefined" && elementStyles.value.paddingLeft !== "0px" ? elementStyles.value.paddingLeft : 0} 0 0 0 rgba(74, 226, 144, 0.5), 0 -${typeof elementStyles.value.marginTop !== "undefined" && elementStyles.value.marginTop !== "0px" ? elementStyles.value.marginTop : 0} 0 0 rgba(226, 135, 74, 0.5), ${typeof elementStyles.value.marginRight !== "undefined" && elementStyles.value.marginRight !== "0px" ? elementStyles.value.marginRight : 0} 0 0 0 rgba(226, 135, 74, 0.5), 0 ${typeof elementStyles.value.marginBottom !== "undefined" && elementStyles.value.marginBottom !== "0px" ? elementStyles.value.marginBottom : 0}  0 0 rgba(226, 135, 74, 0.5), -${typeof elementStyles.value.marginLeft !== "undefined" && elementStyles.value.marginLeft !== "0px" ? elementStyles.value.marginLeft : 0} 0 0 0 rgba(226, 135, 74, 0.5)`
        };
      }
      return {
        top: `${outlinePosition.top.value}px`,
        left: `${outlinePosition.left.value}px`,
        width: `${outlinePosition.width.value}px`,
        height: `${outlinePosition.height.value}px`,
        borderWidth: "2px",
        borderColor: "rgba(12, 140, 233, 1)"
      };
    }
    return {};
  });
  const inStudio = ref(false);
  const route = useRoute();
  if (typeof route.query["voix-sync"] !== "undefined") {
    inStudio.value = true;
  }
  function onBounding(bounding) {
    outlinePosition.height.value = bounding.height.value;
    outlinePosition.bottom.value = bounding.bottom.value;
    outlinePosition.left.value = bounding.left.value;
    outlinePosition.right.value = bounding.right.value;
    outlinePosition.top.value = bounding.top.value;
    outlinePosition.width.value = bounding.width.value;
  }
  return { inStudio, highlightStyles, onBounding };
}
